import axios from 'axios';
import store from '../store';
//defaults
axios.defaults.maxRedirects = 5;
axios.defaults.headers = {
    "Authorization": store.getters.belit_api_token,
    "Accept": "application/json",
};

// variables
let config = {
        headers:{
            "Authorization": store.getters.belit_api_token,
            "Accept": "application/json",
        },
};

//functions after import of this file
export default {

    get(route, data = {}, headers = null){
        headers = (headers) ? headers : config.headers;
        return axios.get(store.getters.belit_api + route, {
            headers,
            params: data
        }).then(response => {
            return response;
        })
    },
    post(route, data = {}, headers = null){
        headers = (headers) ? headers : config.headers;
        return axios.post(store.getters.belit_api + route, data).then(response => {
            return response;
        })
    }
}